import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import PersonaliseExperience from "../../components/PersonaliseExperience";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { saveProfileData } from "../../redux/UserDataSlice";
import { useLocation } from "react-router-dom";

const AvatarName = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState("");

    const { userId, accessToken } = useSelector((state) => state.loginInfo);
    const location = useLocation();
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value.trim().length < 5) {
            setError("Avatar name must be at least 5 characters.");
        } else {
            setError("");
        }
    };
    useEffect(() => {
        if ( location.state?.avatarName ) {
            setInputValue( location.state.avatarName );
        }
    }, [location.state]);


    const onNavigateButton = () => {
        if (inputValue.trim().length < 3) {
            setError("Avatar name must be at least 5 characters.");
            return;
        }
        navigate("/location", { state: { inputValue } });
    };

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const result = await apiHandler({
                    url: `${endpoint.PLAYER_PROFILE}?id=${userId}`,
                    method: "GET",
                    authToken: accessToken?.accessToken,
                });

                if (result?.data?.baseProfile?.avatarName) {
                  location.state?.avatarName ?  setInputValue( location.state.avatarName ) :   setInputValue(result.data.baseProfile.avatarName);
                }

                dispatch(saveProfileData(result?.data));
            } catch (error) {
                console.error("Error fetching profile data:", error);
            }
        };

        if (userId && accessToken?.accessToken) {
            fetchProfileData();
        }
    }, [userId, accessToken, dispatch]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
            <PersonaliseExperience
                navigationRoute='/home'
                title="Personalise your experience"
                subtitle="Choose your sport and level."
                style={{ width: "33%" }}
                data={
                    <>
                        <div>
                            <CustomInput
                                label="Avatar name"
                                placeholder="Your avatar must be at least 5 characters"
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                error={error}
                            />
                            {error && <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{error}</p>}
                        </div>
                        <div className="pt-4">
                            <CustomButton
                                buttonText="Next"
                                className="border"
                                style={{ width: '100%', height: '48px', borderRadius: '12px', background: '#006FFD', color: '#FFFFFF' }}
                                onClick={onNavigateButton}
                                disabled={error}
                            />
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default AvatarName;
